
let defaultState = {
    x: 0, y: 0, // Rotation Vec2

    delta: 0
}

export default function (state=defaultState, action) {

    switch (action.type) {

        case "CAMERA_ROTATION_CHANGE":
            let delta = Math.abs(action.y - state.y) 
            return Object.assign({}, state, {

                x: action.x,
                y: action.y,

                delta: (delta <= 0.1) ? state.delta : delta,

            })
        break;

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/camera.js